import React, { Dispatch, SetStateAction, useEffect, useState, useContext } from 'react';
import SelectSettings, { MenuContents } from '../../organisms/SelectSettings';
import TrendSettingPage from './TrendSetting/TrendSettingPage';
import RealtimeSettingPage from './RealTimeSetting/RealtimeSettingPage';
import PhaseCurrentSetting from './PhaseCurrentSetting';
import RawWaveformsComparisonSetting from './RawWaveformsComparisonSetting';
import RawWaveformComparisonConanSetting from './RawWaveformComparisonConanSetting/RawWaveformComparisonConanSetting';
import FFTComparisonSetting from './FFTComparisonSetting';
import FFTComparisonConanSetting from './FFTComparisonConanSetting/FFTComparisonConanSetting';
import XYComparisonSetting from './XYCompansonSetting/XYComparisonSetting';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
    },
    paper: {
      background: '#FFFFEE',
    },
  })
);

type GroupSettingsProps = {};

const GroupSettingsPage: React.FC<GroupSettingsProps> = (props: GroupSettingsProps) => {
  const { login } = useContext(AppContext);
  const { t } = useTranslation();
  const classes = useStyles();
  console.log('== GroupSettings ==');

  //コナンエア画面有効フラグ
  const conanairEnabled: boolean = login.GetSystemSettingModel.ConanairEnabled === 1 ? true : false;

  const menuList: MenuContents[] = [];

  menuList.push({ name: t('GroupSettingsPage.傾向管理', '傾向管理'), component: TrendSettingPage, tag: 'Trend' });

  if (!login.IsIoT) {
    menuList.push({
      name: t('GroupSettingsPage.リアルタイムトレンド', 'リアルタイムトレンド'),
      component: RealtimeSettingPage,
      tag: 'Realtime',
    });
  }

  menuList.push({ name: t('GroupSettingsPage.電流診断', '電流診断'), component: PhaseCurrentSetting, tag: 'Current' });

  menuList.push({
    name: t('GroupSettingsPage.生波形比較', '生波形比較'),
    component: RawWaveformsComparisonSetting,
    tag: 'Raw',
  });

  if (conanairEnabled) {
    menuList.push({
      name: t('GroupSettingsPage.生波形比較_コナン', '生波形比較(コナン)'),
      component: RawWaveformComparisonConanSetting,
      tag: 'RawConan',
    });
  }

  menuList.push({ name: t('GroupSettingsPage.FFT比較', 'FFT比較'), component: FFTComparisonSetting, tag: 'FFT' });

  if (conanairEnabled) {
    menuList.push({
      name: t('GroupSettingsPage.FFT比較_コナン', 'FFT比較(コナン)'),
      component: FFTComparisonConanSetting,
      tag: 'FFTConan',
    });
  }

  menuList.push({ name: t('GroupSettingsPage.X-Y分布', 'X-Y分布'), component: XYComparisonSetting, tag: 'XY' });

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginRight: 0 }}>
      <SelectSettings menuList={menuList} />
    </Grid>
  );
};

export default GroupSettingsPage;
